<template>
  <hm-content title="">
    <div class="flex flex-wrap">
      <div class="calendar-wrapper">
        <el-button
          type="primary"
          @click="add"
          size="small"
          style="margin:10px 20px"
          >新建计划</el-button
        >
        <hm-calendar
          @getStartAndEndDay="getStartAndEndDay"
          ref="calendar"
          @changeMonth="changeMonth"
          @switchDay="switchDay"
          :checkedInDays="actDays"
        ></hm-calendar>
        <!-- <hm-calendar
          @getStartAndEndDay="getStartAndEndDay"
          ref="calendar"
          @changeMonth="changeMonth"
          @switchDay="switchDay"
          :checkedInDays="actDays"
        ></hm-calendar> -->
      </div>
      <div class="flex-1">
        <hm-pc-calendar
          @getStartAndEndDay="getPcStartAndEndDay"
          ref="calendarpc"
          @changePcMonth="changePcMonth"
          @switchDay="switchDay"
          @goMonth="goMonth"
          @double="add"
          :checkedInDays="checkedInDays"
          :actDays="xdd"
        ></hm-pc-calendar>
      </div>
    </div>
    <el-dialog
      title="新增计划"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <el-dialog
        width="500px"
        title="新增计划类型"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form
          :model="ruleFormType"
          :rules="rulesType"
          label-width="140px"
          ref="ruleFormType"
        >
          <el-form-item label="计划类型颜色：" prop="itemValue">
            <el-color-picker
              color-format="rgb"
              v-model="ruleFormType.itemValue"
              size="small"
            ></el-color-picker>
          </el-form-item>
          <el-form-item label="计划类型：" prop="itemText">
            <el-input
              clearable
              style="width:300px"
              v-model.trim="ruleFormType.itemText"
              maxlength="110"
              size="small"
              placeholder="请输入计划类型"
              class="ipt mr10"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <!-- <div class="flex item-center">
          <el-color-picker
            color-format="rgb"
            v-model="itemValue"
            size="small"
          ></el-color-picker>
          <el-input
            clearable
            style="width:370px"
            v-model.trim="itemText"
            maxlength="110"
            size="small"
            placeholder="请输入计划类型"
            class="ipt mr10"
          >
          </el-input>
        </div> -->
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="save('ruleFormType')" size="small" type="primary"
            >保存</el-button
          >
          <el-button @click="innerVisible = false" size="small" type="primary"
            >关闭</el-button
          >
        </span>
      </el-dialog>
      <el-form
        :model="ruleForm"
        :rules="rules"
        label-width="140px"
        ref="ruleForm"
      >
        <el-form-item label="计划名称：" prop="planName">
          <div class="flex item-center planType">
            <!-- <el-color-picker
              disabled
              @change="color1Change"
              color-format="rgb"
              v-model="ruleForm.color1"
              size="small"
            ></el-color-picker> -->
            <div
              class="planType-color"
              :style="`background:${ruleForm.color1}`"
            ></div>
            <el-input
              clearable
              style="width:370px"
              v-model.trim="ruleForm.planName"
              maxlength="110"
              size="small"
              placeholder="请输入计划名称，建议10字内"
              class="ipt mr10"
            >
              <el-select
                v-model="ruleForm.typeId"
                slot="prepend"
                style="width:150px"
                placeholder="请选择"
                @change="actTypeListChange"
              >
                <el-option
                  :label="v.itemText"
                  :value="v.id"
                  v-for="(v, i) in actTypeList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-input>
            <el-button type="text" size="small" @click="innerVisible = true"
              >新增计划类型</el-button
            >
          </div>
        </el-form-item>

        <el-form-item label="计划时间：" prop="applyDate">
          <el-date-picker
            v-model="ruleForm.applyDate"
            type="daterange"
            align="right"
            start-placeholder="请选择时间段"
            end-placeholder="请选择时间段"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            size="small"
            class=" mr10 time"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="计划描述：" prop="planRemark">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入计划描述内容"
            v-model="ruleForm.planRemark"
            style="width: 400px"
            show-word-limit
            maxlength="500"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="submitRuleForm('ruleForm')"
          size="small"
          type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-calendar v-model="currentDate" id="calendar" v-if="false">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div :class="data.isSelected ? 'is-selected' : ''">
          {{
            data.day
              .split("-")
              .slice(1)
              .join("-")
          }}
          <!-- {{ data.day }} -->
          {{ data.isSelected ? "✔️" : "" }}
        </div>

        <div v-for="(item, i) in calendarData" :key="i">
          <div v-if="item.year.indexOf(data.day.split('-').slice(0)[0]) != -1">
            <div
              v-if="item.months.indexOf(data.day.split('-').slice(1)[0]) != -1"
            >
              <div
                v-if="
                  item.days.indexOf(
                    data.day
                      .split('-')
                      .slice(2)
                      .join('-')
                  ) != -1
                "
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.things"
                  placement="right"
                >
                  <div
                    class="is-select"
                    :style="
                      `background:${item.color.background};color:${item.color.color};borderLeft:3px solid ${item.color.color}`
                    "
                  >
                    {{ item.things }}
                  </div>
                </el-tooltip>
              </div>
              <div v-else></div>
            </div>
            <div v-else></div>
          </div>
        </div>
      </template>
    </el-calendar>
  </hm-content>
</template>

<script>
import moment from "moment";
import HmCalendar from "@/components/HmCalendar";
import HmPcCalendar from "@/components/HmPcCalendar";
export default {
  components: {
    HmCalendar,
    HmPcCalendar
  },
  data() {
    const typeIdFunc = (rule, val, callback) => {
      if (this.ruleForm.typeId === "") {
        return callback(new Error("请选择计划类型"));
      }

      callback();
    };
    return {
      sysDict: {},
      itemText: "",
      itemValue: "",
      ruleFormType: {
        itemText: "",
        itemValue: ""
      },
      rulesType: {
        itemValue: {
          required: true,
          message: "请选择计划类型颜色",
          trigger: "change"
        },
        itemText: {
          required: true,
          message: "请输入计划类型",
          trigger: "change"
        }
      },
      ruleForm: {
        planName: "",
        color1: "",
        typeId: "",
        applyDate: [],
        planRemark: ""
      },
      rules: {
        planName: [
          {
            required: true,
            message: "请填写计划名称",
            trigger: "change"
          },
          {
            required: true,
            validator: typeIdFunc,
            trigger: "change"
          }
        ],
        applyDate: {
          required: true,
          message: "请选择时间段",
          trigger: "change"
        }
      },
      dialogVisible: false,
      innerVisible: false,
      actDays: [],
      currentDate: new Date(),
      checkedInDays: [],
      actTypeList: [],
      xdd: [
        // {
        //   planName: "吃宵夜",
        //   startTime: "2020-07-08 15:43:05",
        //   endTime: "2020-07-22 15:43:23",
        //   locateIndex: [
        //     10,
        //     11,
        //     12,
        //     13,
        //     14,
        //     15,
        //     16,
        //     17,
        //     18,
        //     19,
        //     20,
        //     21,
        //     22,
        //     23,
        //     24
        //   ],
        //   index: "b",
        //   color: {
        //     background: "rgb(255, 127, 16,0.3)",
        //     color: " rgb(255, 127, 16)"
        //   },
        //   typeName:
        //     "手机号1222222222222222222222手机号1222222222222222222222手机号1222222222222222222222手机号1222222222222222222222手机号1222222222222222222222"
        // },
        // {
        //   planName: "看电影",
        //   startDate: "2020-07-21",
        //   endDate: "2020-07-31",
        //   startTime: "2020-07-21 15:43:05",
        //   endTime: "2020-07-31 15:43:23",
        //   locateIndex: [23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33],
        //   typeName: "手机号",
        //   index: "a",
        //   color: { background: "#cae4f8", color: " #0081e5" }
        // },
        // {
        //   planName: "去死",
        //   startDate: "2020-07-21",
        //   endDate: "2020-07-31",
        //   startTime: "2020-07-21 15:43:05",
        //   endTime: "2020-07-31 15:43:23",
        //   locateIndex: [23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 41],
        //   typeName: "手机号",
        //   index: "a",
        //   color: { background: "#cae4f8", color: " #0081e5" }
        // }
      ],
      calendarData: [
        {
          year: ["2020"],
          months: ["07", "11"],
          days: "15",
          things: "看电影",
          color: { background: "#cae4f8", color: " #0081e5" }
        },
        {
          year: ["2020"],
          months: ["07", "11"],
          days: "02",
          things: "去公园野炊",
          color: { background: "#cae4f8", color: " #0081e5" }
        },
        {
          year: ["2020"],
          months: ["07"],
          days: "04",
          things: "看星星",
          color: { background: "#cae4f8", color: "#0081e5" }
        },
        {
          year: ["2020"],
          months: ["07"],
          days: "02",
          things: "看月亮",
          color: { background: "#f5deca", color: " #FF7F10" }
        }
      ],
      statrtDate: "",
      date: {}
    };
  },
  computed: {},
  watch: {
    currentDate(val) {}
  },
  created() {},
  mounted() {
    // this.xdd.forEach(v => {
    //   v.startYear = v.activeStartTime.split("-").slice(0)[0];
    //   v.startMonth = v.activeStartTime.split("-").slice(1)[0];
    //   v.startDays = v.activeStartTime
    //     .split("-")
    //     .slice(2)[0]
    //     .substring(0, 2);
    // });
    // this.actDays = this.xdd;
    // this.$nextTick(() => {
    //   // 点击前一个月
    //   let prevBtn = document.querySelector(
    //     ".el-calendar__button-group .el-button-group>button:nth-child(1)"
    //   );
    //   prevBtn.addEventListener("click", () => {
    //   });
    // });
    // this.$nextTick(() => {
    //   // 点击后一个月
    //   let prevBtn = document.querySelector(
    //     ".el-calendar__button-group .el-button-group>button:last-child"
    //   );
    //   prevBtn.addEventListener("click", () => {
    //   });
    // });
  },
  methods: {
    actTypeListChange(val) {
      this.actTypeList.find(v => {
        if (v.id === val) {
          this.ruleForm.color1 = v.itemValue;
        }
      });
    },
    async queryActTypeList() {
      let params = {
        dictCode: "active_plan_type"
      };
      const { result } = await this.$store.dispatch("queryActTypeList", params);
      const { sysDict, sysDictItem } = result;
      this.sysDict = sysDict;
      this.actTypeList = sysDictItem;
      if (this.actTypeList.length === 0) {
        this.$message({
          message: "请先新增计划类型",
          type: "warning"
        });
      }
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = [
            {
              dictId: this.sysDict.id,
              itemText: this.ruleFormType.itemText,
              itemValue: this.ruleFormType.itemValue
            }
          ];
          this.$store.dispatch("addActTypeDict", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.innerVisible = false;
              this.resetRuleFormType();
              this.queryActTypeList();
            }
          });
        } else {
          return false;
        }
      });
      // if (this.itemText !== "" && this.itemValue !== "") {
      //   let params = [
      //     {
      //       dictId: this.sysDict.id,
      //       itemText: this.itemText,
      //       itemValue: this.itemValue
      //     }
      //   ];
      //   const { code } = await this.$store.dispatch("addActTypeDict", params);
      //   if (code === "0") {
      //     this.$message({
      //       message: "操作成功",
      //       type: "success"
      //     });
      //     this.innerVisible = false;
      //     this.resetRuleFormType()
      //     this.queryActTypeList();
      //   }
      // } else {
      //   this.$message({
      //     message: "请填写计划类型,选择颜色!",
      //     type: "warning"
      //   });
      // }
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          params.startTime =
            this.ruleForm.applyDate && this.ruleForm.applyDate.length > 0
              ? `${this.ruleForm.applyDate[0]} 00:00:00`
              : null;
          params.endTime =
            this.ruleForm.applyDate && this.ruleForm.applyDate.length > 0
              ? `${this.ruleForm.applyDate[1]} 23:59:59`
              : null;
          this.$store.dispatch("addActivePlan", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.resetRuleForm();
              this.$refs.calendarpc.queryPlanTimeList(
                this.date.statrtDate.replace(/\//g, "-"),
                this.date.endDate.replace(/\//g, "-")
              );
              // this.queryList();
              // this.queryFollowupRecordNum(
              //   this.date.statrtDate.replace(/\//g, "-"),
              //   this.date.endDate.replace(/\//g, "-")
              // );
              this.dialogVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    resetRuleFormType() {
      setTimeout(() => {
        this.$refs.ruleFormType.resetFields();
      }, 0);
    },
    add() {
      this.resetRuleForm();
      this.queryActTypeList();
      this.dialogVisible = true;
    },
    async queryCalendarActivity(date) {
      // console.warn(date.replace(/\//g, "-"));
      //   const loginInfo = getCookie({ key: "loginInfo" });
      //   if (date) {
      //     const result = await post(
      //       { url: "/guide/memberCenterInfo/queryFollowupRecordList" },
      //       {
      //         storeCode: loginInfo.storeCode,
      //         employeeId: loginInfo.employeeId,
      //         followupStartTime: date + " 00:00:00",
      //         followupEndTime: date + " 23:59:59",
      //         pageSize: 9999,
      //         pageNo: 1
      //       }
      //     );
      //     const { records } = result;
      //     this.activitys = records;
      //   }
    },
    goMonth(currentMonth) {
      this.$refs.calendar.goMonth(currentMonth);
    },
    changePcMonth(date) {
      this.signedDate = date;
      this.$refs.calendarpc.getStartAndEndDay();
    },
    changeMonth(date) {
      this.signedDate = date;
      this.$refs.calendar.getStartAndEndDay();
    },
    switchDay(date) {
      this.queryCalendarActivity(date);
      if (this.$refs.calendarpc) {
        let currentYear = date.split("/")[0];
        let currentMonth = date.split("/")[1];
        this.$refs.calendarpc.changeDays(currentYear, currentMonth);
      }

      if (this.$refs.calendar) {
        this.$refs.calendar.getStartAndEndDay();
      }
    },

    async queryFollowupRecordNum(statrtDate, endDate) {
      // if (this.statrtDate !== statrtDate) {
      //   let params = {
      //     startTime: `${statrtDate} 00:00:00`,
      //     endTime: `${endDate} 23:59:59`
      //   };
      //   //获取当前日历开始日期和结束日期
      //   const { result } = await this.$store.dispatch(
      //     "queryPlanTimeList",
      //     params
      //   );
      //   this.xdd = result;
      //   if (this.xdd.length) {
      //     this.xdd.forEach(v => {
      //       v.color = {
      //         color: v.color,
      //         background: v.color.slice(0, -1) + ",0.3" + v.color.slice(-1)
      //       };
      //     });
      //   }
      // }
    },
    getStartAndEndDay(date) {
      // this.queryFollowupRecordNum(
      //   date.statrtDate.replace(/\//g, "-"),
      //   date.endDate.replace(/\//g, "-")
      // );
    },
    getPcStartAndEndDay(date) {
      this.date = date;

      this.queryFollowupRecordNum(
        date.statrtDate.replace(/\//g, "-"),
        date.endDate.replace(/\//g, "-")
      );

      this.statrtDate = date.statrtDate.replace(/\//g, "-");
    }
  }
};
</script>
<style lang="scss">
.planType {
  .el-input-group__prepend {
    .el-input__inner {
      padding-left: 40px;
    }
  }
}
.calendar-day {
  text-align: center;
  color: #202535;
  line-height: 30px;
  font-size: 12px;
}
.is-select-plan {
  padding: 5px 5px;
  font-size: 14px;
  margin-top: 5px;
  height: 20px;
  line-height: 20px;
  // width: 131px;
  // color: #f5deca;
  // background: #cae4f8;
  // color: #0081e5;
  // border-left: 3px solid #0081e5;
  // &::before {
  //   display: inline-block;
  //   // margin-right: 10px;
  //   content: "";
  //   width: 4px;
  //   height: 12px;
  //   background: #0081e5;
  //   border-top-left-radius: 30px;
  //   border-bottom-right-radius: 30px;
  // }
}
.el-calendar-table .el-calendar-day {
  height: 100px;
}
// #calendar
//   .el-button-group
//   > .el-button:not(:first-child):not(:last-child):after {
//   content: "当月";
// }
</style>
<style lang="scss" scoped>
.calendar-wrapper {
  background: linear-gradient(135deg, #eb7fae, #1d70f2, #0661ed);
}
.planType {
  .planType-color {
    width: 22px;
    height: 22px;
    border-radius: 4px;
    margin-right: -30px;
    z-index: 1;
  }
}
</style>
